import getFieldsByName from './get_fields_by_name';

/**
 * Gets a the first active field by name in the form
 */
export default function getFieldByName(form, name) {
  return getFieldsByName(form, name)[0];
}
